import * as z from "zod";

export const getEmailAiBlockedTeams = {
  name: "getEmailAiBlockedTeams" as const,
  input: z.object({}),
  output: z.object({
    teams: z.array(z.object({ teamId: z.string(), teamName: z.string() })),
  }),
};
